<template>
	<div>
		<Spin v-if="innerLoading" fix>
			<Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
			<div>{{ $t('global.loading') }}</div>
		</Spin>
		<div v-else>
			<div
				v-for="stage in (competitionIsOngoing ? competition.stages.filter(({ isCurrent }) => isCurrent) : competition.stages)">
				<!-- <h1 class="mt-2 mb-4">{{ competitionIsOngoing ? $t("competition.current") +  " -" : null }}
					{{ stage.name }}</h1> -->
				<Row :gutter="16" class="d-flex flex-wrap">
					<Col :span="spanCount" v-if="spec === 'oneway'" v-for="round in (competitionIsOngoing ? rounds : stage.rounds)" :key="round._id">
						<Card class="tournament-stage table-card-style mb-3">
							<table class="match-table res table-margin">
								<thead class="teams-table-style">
									<tr class="first-table-row">
										<th class="align-middle" style="font-size: 24px;">
											{{ round.name }}
										</th>
										<th class="w-70px"></th>
									</tr>
									<tr>
										<th>{{ $t('competition.match') }}</th>
										<th style="width: 60px; min-width: 60px;">{{ $t('competition.score') }}</th>
									</tr>
								</thead>
							</table>
							<div>
								<template v-for="(match, index) in matches.filter((match) => match.round._id === round._id)">
									<table :key="index" class="match-table position-relative table-margin">
										<tbody>
											<tr>
												<td style="padding-top: 3px; padding-bottom: 3px; border-right: none;">
													<span style="min-height: 15px; display: inline-block;">
														<small>
															<span v-if="match.start_date">
																{{ getDateMatches(match.start_date) }};
															</span> 
															{{ getMatcheStadium(match) }}
														</small>
													</span>
												</td>
												<td class="w-70px" style="border-left: none;"></td>
											</tr>
											<tr :class="`${getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''}`">
												<td>
													<Tooltip :content="match.home_team.name" placement="top-start" class="w-100">
														<span class="text-overflow-style one-circuit-clamt-text">
															{{ match.home_team.name }}
														</span>
													</Tooltip>
												</td>
												<td class="w-70px position-relative">
													<span v-if="match.home_players">
														{{ getPoints(match.home_players, match, match.home_team) }}
													</span>
													<Icon v-if="!isVisible" role="button" type="md-information-circle" class="icon-pos"
														@click="() => openModal(match)" />
												</td>
											</tr>
											<tr :class="`${getPoints(match.away_players, match, match.away_team) > getPoints(match.home_players, match, match.home_team) ? 'font-weight-bold' : ''}`">
												<td>
													<Tooltip :content="match.away_team.name" placement="top-start" class="w-100">
														<span class="text-overflow-style one-circuit-clamt-text">
															{{ match.away_team.name }}
														</span>
													</Tooltip>
													
												</td>
												<td class="w-70px">
													<span v-if="match.away_players">{{ getPoints(match.away_players, match, match.away_team)
													}}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</template>
							</div>
						</Card>
					</Col>
					<Col span="12" v-if="spec === 'twoway'" v-for="round in (competitionIsOngoing ? rounds : stage.rounds)" :key="round._id">
						<Card class="tournament-stage table-card-style mb-3">
							<table class="match-table table-margin">
								<thead class="teams-table-style">
									<tr class="first-table-row">
										<th class="align-middle" style="font-size: 24px;">
											{{ round.name }}
										</th>
										<th class="w-70px"></th>
										<th></th>
										<th class="w-70px"></th>
									</tr>
									<tr>
										<th colspan="2">
											<h3>Tur</h3>
										</th>
										<th colspan="2">
											<h3>Retur</h3>
										</th>
									</tr>
									<tr>
										<th>{{ $t('competition.match') }}</th>
										<th>{{ $t('competition.score') }}</th>
										<th>{{ $t('competition.match') }}</th>
										<th>{{ $t('competition.score') }}</th>
									</tr>
								</thead>
							</table>
							<div v-if="circuitMatches.length">
								<template v-for="(match, index) in circuitMatches.filter((match) => match.away && match.away.round._id === round._id && match.home.round._id === round._id)">
									<table :key="index" class="match-table table-margin">
										<tbody>
											<tr>
												<td style="padding-top: 3px; padding-bottom: 3px; border-right: none;">
													<span style="min-height: 15px; display: inline-block;">
														<small>
															<span v-if="match.home.start_date">{{ getDateMatches(match.home.start_date) }};</span> {{
																getMatcheStadium(match.home) }}
														</small>
													</span>
												</td>
												<td class="w-70px" style="border-left: none;"></td>
												<td style="padding-top: 3px; padding-bottom: 3px; border-right: none">
													<span style="min-height: 15px; display: inline-block;">
														<small>
															<span v-if="match.away.start_date">{{ getDateMatches(match.away.start_date) }};</span> {{
																getMatcheStadium(match.away) }}
														</small>
													</span>
												</td>
												<td class="w-70px" style="border-left: none;"></td>
											</tr>
											<tr>
												<td :class="`${getPoints(match.home.home_players, match.home, match.home.home_team) > getPoints(match.home.away_players, match.home, match.home.away_team) ? 'font-weight-bold w-300px' : 'w-300px'}`">
													<Tooltip :content="match.home.home_team.name" placement="top-start" class="w-100">
														<span class="text-overflow-style one-circuit-clamt-text">
															{{ match.home.home_team.name }}
														</span>
													</Tooltip>
												</td>
												<td :class="`${getPoints(match.home.home_players, match.home, match.home.home_team) > getPoints(match.home.away_players, match.home, match.home.away_team)
													? 'font-weight-bold w-70px position-relative'
													: 'w-70px position-relative'
													}`">
													<span> {{
														getPoints(match.home.home_players, match.home, match.home.home_team) }}</span>
													<Icon v-if="!isVisible" role="button" type="md-information-circle" class="icon-pos"
														@click="() => openModal(match.home)" />
												</td>
												<td :class="`${getPoints(match.away.home_players, match.away, match.away.home_team) > getPoints(match.away.away_players, match.away, match.away.away_team) ? 'font-weight-bold w-300px' : 'w-300px'}`">
													<Tooltip :content="match.away.home_team.name" placement="top-start" class="w-100">
														<span class="text-overflow-style one-circuit-clamt-text">
															{{ match.away.home_team.name }}
														</span>
													</Tooltip>
												</td>
												<td :class="`${getPoints(match.away.home_players, match.away, match.away.home_team) > getPoints(match.away.away_players, match.away, match.away.away_team)
													? 'font-weight-bold w-70px position-relative'
													: 'w-70px position-relative'
													}`">
													<span>{{ getPoints(match.away.home_players, match.away, match.away.home_team) }}</span>
													<Icon v-if="!isVisible" role="button" type="md-information-circle" class="icon-pos"
														@click="() => openModal(match.away)" />
												</td>
											</tr>
											<tr>
												<td :class="`${getPoints(match.home.away_players, match.home, match.home.away_team) > getPoints(match.home.home_players, match.home, match.home.home_team) ? 'font-weight-bold w-300px' : 'w-300px'}`">
													<Tooltip :content="match.home.away_team.name" placement="top-start" class="w-100">
														<span class="text-overflow-style one-circuit-clamt-text">
															{{ match.home.away_team.name }}
														</span>
													</Tooltip>
												</td>
												<td :class="`${getPoints(match.home.away_players, match.home, match.home.away_team) > getPoints(match.home.home_players, match.home, match.home.home_team) ? 'font-weight-bold w-70px' : 'w-70px'}`">
													<span>{{
														getPoints(match.home.away_players, match.home, match.home.away_team) }}</span>
												</td>
												<td :class="`${getPoints(match.away.away_players, match.away, match.away.away_team) > getPoints(match.away.home_players, match.away, match.away.home_team) ? 'font-weight-bold w-300px' : 'w-300px'}`">
													<Tooltip :content="match.away.away_team.name" placement="top-start" class="w-100">
														<span class="text-overflow-style one-circuit-clamt-text">
															{{ match.away.away_team.name }}
														</span>
													</Tooltip>
												</td>
												<td :class="`${getPoints(match.away.away_players, match.away, match.away.away_team) > getPoints(match.away.home_players, match.away, match.away.home_team) ? 'font-weight-bold w-70px' : 'w-70px'}`">
													<span> {{ getPoints(match.away.away_players, match.away, match.away.away_team) }}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</template>
							</div>
						</Card>
					</Col>
				</Row>
			</div>
			<!-- <MatchCircuitModal v-if="circuitModal" :match="selectedMatch" :competition="competition" @close="(e) => close(e)" /> -->
		</div>
	</div>
</template>

<script>
import MatchCircuitModal from './MatchCircuitModal.vue';
import storeMixin from './storeMixin';

export default {
	name: 'Circuit',
	components: { MatchCircuitModal },
	data() {
		return storeMixin;
	},
	async created() {
		console.log("mounted");
		this.innerLoading = true;
		this.competitionIsOngoing = Boolean(this.competition.stages.filter(({ isCurrent }) => isCurrent).length)
		if (this.competitionIsOngoing) {
			console.log(this.competition.stages.find(({ isCurrent }) => isCurrent));
			this.saveRounds(this.competition.stages.find(({ isCurrent }) => isCurrent).rounds)
		}

		// await this.detectCurrentStage()
		if (this.competitionIsOngoing) {
			await this.getCurrentTeams();
			if ((!this.rounds.filter((round) => round.category === this.$route.params.cat).length)) {
				await this.generateRounds()
			}
			if (!this.isVisible)
				await this.getAllMatches(this.competition.stages.filter(({ isCurrent }) => isCurrent))
			if (this.spec === 'oneway') {
				this.checkForMatches();
			} else if (this.spec === 'twoway') {
				this.checkForPairMatches();
			}
		} else {
			// await this.getAllMatches(this.competition.stages)
			if (this.spec === 'oneway') {
				this.checkForMatches();
			} else if (this.spec === 'twoway') {
				this.checkForPairMatches();
			}
		}
		console.log(this.matches);
		this.innerLoading = false;

	},
	mounted() {
		this.getWidth();
		window.onresize = () => {
			this.getWidth();
		};
	},
};
</script>

<style scoped>
.w-70px {
	width: 70px;
	min-width: 70px;
}

.w-300px {
	width: 300px;
}

.icon-pos {
	position: absolute;
	bottom: -0.5rem;
	left: -0.5rem;
	color: #2d8cf0;
	font-size: 20px;
	background: white;
	border-radius: 50%;
	width: 16px;
	height: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.icon-pos:hover {
	transform: scale(1.15);
}

.one-circuit-clamt-text {
	width: 100%;
}

table {
	table-layout: fixed;
}</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/Circuit.vue